//@flow
import React from 'react'
import iconCorrect from './correct.svg'
import iconIncorrect from './incorrect.svg'
import iconCursor from './cursor-hand.svg'
import iconInfo from './info.svg'
import firebase from 'firebase/app'
import 'firebase/database'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

let answerPercent = 0
let comparePercent = 0

const isMobile = browserCheck.isMobile

const FeedbackIcon = (props) => {
  return(
    <div className="feedback-icon">
      {!props.isCorrect && (
        <img src={iconIncorrect} className='incorrect-icon' alt='incorrect' />
      )}
      {props.isCorrect && (
        <img src={iconCorrect} className='correct-icon' alt='correct' />
      )}
    </div>
  )
}


export class Question extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      userAnswer: null,
      localAnswer: null,
      isCorrect: null,
      totalVotes: 0,
      answerLeftPercent: null,
      answerRightPercent: null,
      isInView: false
    }
     // Init Firebase
     const config = {
      apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
      authDomain: 'quiz-battle.europe-west1.firebasedatabase.app',
      databaseURL: 'https://quiz-battle.europe-west1.firebasedatabase.app',
      storageBucket: 'ta-interaktiv.appspot.com'
    }
    if (!firebase.apps.length) {
      // console.log('firebase.apps', firebase.apps)
      firebase.initializeApp(config)
    }
  }

  evaluate(answer) {
    if(this.state.localAnswer !== null && this.state.userAnswer === null) {
      this.setState({userAnswer: this.state.localAnswer})
      if(answer === this.props.quizzesData[this.props.questionID].c) {
        this.setState({isCorrect: true})
      } else {
        this.setState({isCorrect: false})
      }
  } else if(this.state.userAnswer === null) {
      this.setState({userAnswer: answer})
      if(answer === this.props.quizzesData[this.props.questionID].c) {
        this.setState({isCorrect: true})
      } else {
        this.setState({isCorrect: false})
      }
      if(answer === 'left') {
        this.addVote('l')
      } else {
        this.addVote('r')
      }

      // LOCAL STORAGE
      const storedAnswers =  JSON.parse(localStorage.getItem(this.props.quizzesData['firebase-id']))
      if (storedAnswers !== null && storedAnswers !== undefined) {
        const storedAnswer =  storedAnswers[this.props.questionID]
        if (storedAnswer === null || storedAnswer === undefined) {
          const newAnswers = storedAnswers
          newAnswers[this.props.questionID] = answer 
          localStorage.setItem(this.props.quizzesData['firebase-id'], JSON.stringify(newAnswers))
        }
      } else {
        const answerObj = {
          [this.props.questionID]: answer
          }
        localStorage.setItem(this.props.quizzesData['firebase-id'], JSON.stringify(answerObj))
      }

       // track in google analytics
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `evaluate:` + this.props.quizzesData['firebase-id'] + '/' + this.props.questionID
      })
    }
  }

  /* increment in firebase */
  addVote(answer) {
    const newVote = firebase
      .database()
      .ref(this.props.quizzesData['firebase-id'] + '/' + this.props.questionID + '/' + answer)
    newVote.transaction(
      currentVotes => {
        return currentVotes + 1
      },
      (error, committed, snapshot) => {
        if (error) {
          // console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          // console.log('Transaction aborted')
        } else {
          this.getVotes()
        }
      }
    )
  }

  getVotes() {
    // console.log('get votes rom firebase for', this.state.tippID)
    firebase
      .database()
      .ref(this.props.quizzesData['firebase-id'] + '/' + this.props.questionID + '/')
      .once('value')
      .then(snapshot => {
        const leftVotes = snapshot.child('l').val()
        const rightVotes = snapshot.child('r').val()
        const answerLeftPercent = leftVotes/(leftVotes+rightVotes) * 100
        const answerRightPercent = rightVotes/(leftVotes+rightVotes) * 100
        this.setState({
          totalVotes: leftVotes+rightVotes,
          answerLeftPercent: Math.round(answerLeftPercent) || 0,
          answerRightPercent: Math.round(answerRightPercent) || 0
        })
      })
    //this.getLocalVotes()
  }

  getLocalVotes() {
    const localVote = JSON.parse(localStorage.getItem(this.props.quizzesData['firebase-id']))
   // console.log('localVote', localVote)
    if (localVote !== null && localVote !== undefined) {
      if (localVote[this.props.questionID] !== null && localVote[this.props.questionID] !== undefined) {
        this.setState({
          localAnswer: localVote[this.props.questionID]
        }, function() {
          if(this.state.localAnswer === 'left') {
            this.evaluate(this.state.localAnswer)
          } else {
            this.evaluate(this.state.localAnswer)
          }
        }.bind(this))
      }
    }
  }


  // helpers
  numberWithApostroph(x) {
      let num = x.toString()
      if(num.length > 4) {
        num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
      }
      return num;
  }
  numberWithComma(x) {
    return x.toString().replace('.', ',')
  }
  
  componentDidMount() {
    this.getVotes()
    this.getLocalVotes()
  }

  render() {
    const questionData = this.props.quizzesData[this.props.questionID]
    // console.log('questionData:', questionData)
    return <div className='battle'>
      <h3>{questionData.title}</h3>
      <div className={this.state.isCorrect === true ? 'row correct' : 'row incorrect'}>

        <div className={this.state.userAnswer === 'left' ? 'option left selected' : this.state.userAnswer === 'right' ? 'option left disabled' : 'option left'} onClick={() => this.evaluate('left')}>
        <Tippy
          content={<div dangerouslySetInnerHTML={{__html: questionData.infoLeft}} />}
          className='tooltip'
          disabled={this.state.userAnswer === null}
          trigger={'click'}
          placement={isMobile ? 'bottom' : 'left'}
          offset={[0, -100]}
          maxWidth={250}
          theme={'quiz'}
          interactive={true}
        >
            <div className="icon-wrapper">
                <img src={require('../../images/'+questionData.imgLeft)} alt="icon" />
                {this.state.userAnswer === 'left' && (
                <FeedbackIcon isCorrect={this.state.isCorrect} />
              )}
            </div>
        </Tippy>
        </div>

        <Waypoint
            scrollableAncestor={window}
            bottomOffset='-50%'
            onEnter={event => {
              this.setState({ isInView: true })
              // console.log('in view:', this.props.questionID)
            }}
        >
            <div className="divider">
              {this.state.userAnswer === null && (
              <div className='hintcursor' style={{ animationDuration: this.state.isInView ? Math.random(2)+ 4 + 's' : '0'}}>
                <img src={iconCursor} className='cursor-icon' alt='please choose' />
              </div>
              )}
            </div>
        </Waypoint>


        <div className={this.state.userAnswer === 'right' ? 'option right selected' : this.state.userAnswer === 'left' ? 'option right disabled' : 'option right'} onClick={() => this.evaluate('right')}>
        <Tippy
          content={<div dangerouslySetInnerHTML={{__html: questionData.infoRight}} />}
          className='tooltip'
          disabled={this.state.userAnswer === null}
          trigger='click'
          placement={isMobile ? 'bottom' : 'right'}
          offset={[0, -100]}
          maxWidth={250}
          theme={'quiz'}
          interactive={true}
          // appendTo={() => document.body}
          // appendTo={questionData.tooltipRef}
        >
            <div className="icon-wrapper">
                <img src={require('../../images/'+questionData.imgRight)} alt="icon" />
                {this.state.userAnswer === 'right' && (
                  <FeedbackIcon isCorrect={this.state.isCorrect} />
                )}
            </div>
        </Tippy>
        </div>

        {this.state.userAnswer !== null && (
          <>
          <div className="feedback">
            {this.state.isCorrect === false && (
              <>
                <i className='icon false' />
                <div className="text">{this.props.quizzesData.textelements.incorrect.part1} <b>{this.props.quizzesData.textelements.incorrect.part2}</b> {questionData.solution} <b>{this.state.answerLeftPercent !== null && (this.state.userAnswer === 'left' ? this.state.answerLeftPercent : this.state.answerRightPercent)}{this.state.answerLeftPercent === null && (<div className="loader" />)}%</b> der {this.state.totalVotes > 0 && (this.numberWithApostroph(this.state.totalVotes))}{this.state.totalVotes === 0 && (<div className="loader" />)} {this.props.quizzesData.textelements.incorrect.part3} </div>
              </>
            )}
            {this.state.isCorrect === true && (
              <>
                <i className='icon false' />
                <div className="text">{this.props.quizzesData.textelements.correct.part1} <b>{this.props.quizzesData.textelements.correct.part2}</b> {questionData.solution} <b>{this.state.answerRightPercent !== null && (this.state.userAnswer === 'left' ? this.state.answerLeftPercent : this.state.answerRightPercent)}{this.state.answerRightPercent === null && (<div className="loader" />)}%</b> der {this.state.totalVotes > 0 && (this.numberWithApostroph(this.state.totalVotes))}{this.state.totalVotes === 0 && (<div className="loader" />)} {this.props.quizzesData.textelements.correct.part3}</div>
              </>
            )}
          </div>
           <div className="hint">
            <img src={iconInfo} className='correct-icon' alt='correct' />
            {this.isMobile ? this.props.quizzesData.textelements['hint'] : this.props.quizzesData.textelements['hintDesktop']}
         </div>
         </>
        )}

      </div>

    </div>
  }
}
